import React, { useContext } from 'react'
import useErrorBoundary from 'use-error-boundary'
import { Navigate, useLocation } from 'react-router-dom'
import { Error500 } from '../pages'
import { AuthContext, AuthContextType } from '../contexts/authContext'

interface IProps {
    children: React.ReactNode
}
interface IPublic extends IProps {
    public: boolean
    private?: never
}
interface IPrivate extends IProps {
    private: boolean
    public?: never
}
type TProps = IPublic | IPrivate

export default function CustomRoute(props: TProps): React.ReactElement {
    const location = useLocation()
    const { isAuthenticated } = useContext(AuthContext) as AuthContextType

    const { ErrorBoundary, reset } = useErrorBoundary({
        onDidCatch: (error) => {
            if (/Loading chunk [\d]+ failed/.test(error.message)) window.location.reload()
        },
    })

    function render(): React.ReactElement | React.ReactNode {
        if ((props.public && !isAuthenticated()) || (props.private && isAuthenticated())) {
            return props.children
        }
        return <Navigate to={props.private ? '/login' : '/'} state={{ from: location }} replace />
    }

    return <ErrorBoundary render={render} renderError={(): React.ReactElement => <Error500 reset={reset} />} />
}
